import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormArray
} from '@angular/forms';
import { Select2Data } from 'ng-select2-component';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { TalentService } from 'src/app/providers/talent/talent.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
declare let $: any;

@Component({
  selector: 'app-internal-jobs2',
  templateUrl: './internal-jobs2.component.html',
  styleUrls: ['./internal-jobs2.component.scss']
})
export class InternalJobs2Component implements OnInit {
public empStatus = localStorage.getItem('emp_status');
public empEntity = localStorage.getItem('entity');
searchJobForm: FormGroup;
public ijpList: any = [];
// public ijp_filters = [];
result: any;
cityList: any = [];
skillList: any = [];
degsnList: any = [];
ccList: Select2Data = [];
stateList: any = [];
dynamicHeader: any;
empSkillForm: FormGroup;
loading: boolean;
submitted: boolean;
skilList: any;
public currentType: any;
// tslint:disable-next-line: variable-name
emId: any;
docsFile: any = [];
empJobsForm: FormGroup;
jobList: any;
degsnOrgList: Select2Data = [];
cityOrgList: Select2Data = [];
regionList: any;
public cnID: any;
public resultR: any;
public cateList: any;
public type: any = [];
ijpList1: any = [];
appStatus: any;
ijpList2: any = [];
response: any = [];
regionAll: any = [];
ipAddress: any;
ijpListReular: any = [];
public page = 1;
public pageF = 1;
public count = 0;
public countF = 0;
public pageSize = 10;
public pageSizeF = 10;
public from;
public fromF;
public to;
public toF;
ijpListReularCount: any;
ijpListCount: any;
ijpListFTC: any;
ijpListMoreFTC:any;
jobsCategory:any;

tabs = {
  a: true,
  b: false,
};
activeTabR: any;
activeTabF: any;
desginData: any;
option_id :any = [];


constructor(
  private talentService: TalentService,
  private router: Router,
  private genService: GeneralService,
  private authService: AuthService,
  private formBuilder: FormBuilder,
  private notifyService: NotificationService,
  private location: Location
) {
  console.log('jobs ye', document.referrer);
}

ngOnInit(): void { 
  console.log(this.empStatus);
  // this.getIjpMrfs();
  this.searchJobForm = new FormGroup({
    cost_center: new FormControl(),
    skill_type: new FormControl(),
    region: new FormControl(),
    design: new FormControl(),
    state: new FormControl(),
    city: new FormControl(),
    job_type: new FormControl(),
  });

  this.searchJobs();
  this.getJobsFilter();
  this.getStateFilter();
  this.getRegion();
  this.moreJobs();
  this.jobsCategoryDta();
  // this.getDesignation();
}

searchJobs(): void {
  // this.page = 1;
  // this.pageSize = 10;
  // this.pageF = 1;
  // this.pageSizeF = 10;
    this.searchJobsFTC(this.searchJobForm.value);
 
}

jobCat() {
  this.option_id = this.jobsCategory.filter(val => val.isCheck == true);
  this.searchJobsFTC('');
}

latestJob(data):void{
  const param = {
    page: this.pageF,limit: this.pageSizeF,jobs:data
  }
  console.log(param);
  this.authService
    .getIjpMrfsLatestJobs(
      param
    )
    .subscribe(
      (res) => {
        this.result = res;
        this.ijpListFTC = this.result.data.data;
        this.ijpListCount = this.result.count;
        this.countF = this.result.data.total;
        this.fromF = this.result.data.from;
        this.toF = this.result.data.to;

      },
      (err) => {}
    );


};


searchJobsFTC(data): void {
  console.log(data);
  // return;
  console.log(this.option_id);
  console.log(this.option_id);
  const param = {
    ...data,...{page: this.pageF,limit: this.pageSizeF,levelID:JSON.stringify(this.option_id)}
  }
  console.log(param);
  this.authService
    .getIjpMrfsFTCJobs(
      param
    )
    .subscribe(
      (res) => {
        this.result = res;
        this.ijpListFTC = this.result.data.data;
        this.ijpListCount = this.result.count;
        this.countF = this.result.data.total;
        this.fromF = this.result.data.from;
        this.toF = this.result.data.to;

      },
      (err) => {}
    );
}
getRegion(): void {
  this.authService.getAllRegion().subscribe((res) => {
    this.response = res;
    this.regionAll = this.response.data;
    
  });
}
getStateFilter(): void {
  this.authService.getStateForFilter().subscribe((res) => {
    this.result = res;
    this.stateList = this.result.data;
  });
}
getCity(stId): void {
  this.authService.getCityForFilter(stId).subscribe((res) => {
    this.result = res;
    this.cityList = this.result.data;
    // this.result.data.forEach(elct => {
    //   this.cityList.push({label: elct.ct_name, value: elct.ct_id });
    // });
  });
}
getStateCity(event): void {
  let stId;
  stId = event.target.value;
  if (stId === '' || stId == null) {
  } else {
    this.getCity(stId);
  }
}
getJobsFilter(): void {
  this.authService.getInternalJobsFilter().subscribe((res) => {
    this.result = res;
    this.skillList = this.result.data.skill_types;
    // this.result.data.skill_types.forEach(element => {
    //   this.skillList.push({ label: element.label, value: element.value});
    // });
    this.degsnList = this.result.data.designation;
    // .forEach(eld => {
    //   this.degsnList.push({ label: eld.label, value: eld.value});
    // });
    // this.result.data.cost_centers.forEach( elc => {
    //   this.ccList.push({ label: elc.label , value: elc.value});
    // });
  });
}
resetIJPFilter(): void {
  this.searchJobForm.reset();
  this.searchJobs();
}
checkBugetfrom(num): boolean {
  if (this.isFloat(num) == true || this.isInt(num) == true) {
    return true;
  }
  return false;
}
isInt(n): boolean {
  return Number(n) === n && n % 1 === 0;
}

isFloat(n): boolean {
  return Number(n) === n && n % 1 !== 0;
}

logout(): void {
  const params = {
    ip: this.ipAddress,
    source: 'web',
  };
  console.log('pp', params);
  const popUp = localStorage.getItem('popUp');
  const date = localStorage.getItem('date');
  const usrId = localStorage.getItem('usrId');
  const ballon = localStorage.getItem('showBallon');
  const evntDate = localStorage.getItem('eventDate');

  this.authService.logOutFromJobs(params).subscribe(
    (res) => {
      this.result = res;
      // if (this.result.status) {
      localStorage.clear();
      localStorage.setItem('popUp', popUp);
      localStorage.setItem('date', date);
      localStorage.setItem('usrId', usrId);
      localStorage.setItem('showBallon', ballon);
      localStorage.setItem('eventDate', evntDate);

      this.router.navigate(['/']);
      this.notifyService.showSuccess(this.result.msg, 'Success');
      // }
    },
    (err) => {
      localStorage.clear();
      localStorage.setItem('popUp', popUp);
      localStorage.setItem('date', date);
      localStorage.setItem('usrId', usrId);
      localStorage.setItem('showBallon', ballon);
      localStorage.setItem('eventDate', evntDate);

      this.router.navigate(['/']);
      this.notifyService.showSuccess(this.result.msg, 'Success');
    }
  );
}

queryModal(): void {
  this.router.navigate(['/alumni-queries']);
  // $('#show_quer_modal').modal({ backdrop: 'static' , keyboard: false});
}


moreJobs():void{
  this.authService
  .getIjpMrfsMoreFTC()
  .subscribe(
    (res) => {
      this.result = res;
      this.ijpListMoreFTC = this.result.data.data;
    },
    (err) => {}
  );

  
}

jobsCategoryDta():void{
  this.authService.getJobsCategory().subscribe(
    (res) => {
      this.result = res;
      this.jobsCategory = this.result.data;
      console.log("job" + this.jobsCategory);
      console.log("job2" + this.result);
    },
    (err) => {}
  );
}
// getDesignation(): void {
//   this.authService.getDesignation().subscribe( res => {
//     this.result = res;
//     this.desginData = this.result.data;
//   });
// }

toggleSidebar = () => {
  if ($('body').hasClass('mini-sidebar')) {
    $('body').removeClass('mini-sidebar');
    localStorage.setItem('mini-sidebar', '0');
    $('.subdrop + ul').slideDown();
  } else {
    $('body').addClass('mini-sidebar');
    localStorage.setItem('mini-sidebar', '1');
    $('.subdrop + ul').slideUp();
  }
};



}
